<template>
  <div v-if="currentPair" class="pairwise-ranking">

    <div class="header">
      <div class="title">
        <h3 class="h4">Comparison Ranking</h3>
        <p class="instructions">For each pair, select the value you most identify with.</p>
      </div>

      <div class="progress-wrapper">
        <label>Progress:</label>
        <p class="count">{{ currentPairIndex }} of {{ pairs.length }}</p>
        <div class="progress">
        <span v-for="(pair, index) in pairs"
              :class="{complete: index < currentPairIndex}">
        </span>
        </div>
      </div>

    </div>

    <div class="current-pair grid grid-cols-1 sm:grid-cols-2">
      <div class="card" @click="choose(currentPair[0])">
        <div class="card-header">
          <h3 class="card-title h4">{{ currentPair[0].name }}</h3>
        </div>

        <p>{{ currentPair[0].definition_abbr }}</p>
      </div>
      <div class="card" @click="choose(currentPair[1])">
        <div class="card-header">
          <h3 class="card-title h4">{{ currentPair[1].name }}</h3>
        </div>
        <p>{{ currentPair[1].definition_abbr }}</p>
      </div>
    </div>

  </div>
</template>


<script>
export default {
  props: {
    items: {
      type: Array,
    }
  },

  data() {
    return {
      pairs:            [],
      currentPairIndex: 0,
    };
  },
  mounted() {
    for (let i = 0; i < this.items.length; i++) {
      for (let j = i + 1; j < this.items.length; j++) {
        this.pairs.push([this.items[i], this.items[j]]);
      }
    }
    this.pairs = this.shuffle(this.pairs);
    // console.log(this.pairs);
  },
  computed: {
    currentPair() {
      if (this.currentPairIndex < this.items.length * (this.items.length - 1) / 2) {
        return this.pairs[this.currentPairIndex];
      } else {
        return null;
      }
    },
  },
  methods:  {
    choose(item) {
      this.$parent.rankedValues[`${this.currentPair[0].name}-${this.currentPair[1].name}`] = item.name;
      this.currentPairIndex++;

      if (this.currentPairIndex === this.items.length * (this.items.length - 1) / 2) {
        this.$parent.assessmentComplete = true;
      }
    },
    shuffle(array) {
      let currentIndex = array.length;

      // While there remain elements to shuffle...
      while (currentIndex !== 0) {

        // Pick a remaining element...
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    },
  }
}

</script>
